import { css } from "../helpers/webComponents";

const styles: string = css`
    :host {
        background-color: #1D2434;
        border-top: 3px solid #3B4B62;
        color: white;
        display: flex;
        flex-direction: column;
        padding: 10px;
        position: fixed;
        z-index: 1;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
        height: 60%;
    }

    .memory-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 10px;
        margin-top: 10px;
    }

    .card {
        background-color: #3B4B62;
        padding: 20px;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
        user-select: none;
    }

    .card.revealed {
        background-color: #78808D;
    }
`;

export class MemoryGameComponent extends HTMLElement {
    private cards: number[] = [];
    private revealed: number[] = [];
    private matched: Set<number> = new Set();

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    connectedCallback(): void {
        this.initGame();
        this.render();
    }

    private initGame(): void {
        const base = [1, 2, 3, 4, 5, 6];
        this.cards = [...base, ...base].sort(() => Math.random() - 0.5);
    }

    private handleCardClick(index: number): void {
        if (this.revealed.includes(index) || this.matched.has(index)) return;

        this.revealed.push(index);
        this.render();

        if (this.revealed.length === 2) {
            const [first, second] = this.revealed;
            if (this.cards[first] === this.cards[second]) {
                this.matched.add(first);
                this.matched.add(second);
            }

            setTimeout(() => {
                this.revealed = [];
                this.render();

                if (this.matched.size === this.cards.length) {
                    this.dispatchEvent(new CustomEvent("memory-success", { bubbles: true, composed: true }));
                    this.style.display = "none";
                }
            }, 1000);
        }
    }

    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
            <style>${styles}</style>
            <div>Select matching pairs:</div>
            <div class="memory-grid">
                ${this.cards.map((value, index) => `
                    <div class="card ${this.revealed.includes(index) || this.matched.has(index) ? 'revealed' : ''}" data-index="${index}">
                        ${this.revealed.includes(index) || this.matched.has(index) ? value : "?"}
                    </div>
                `).join("")}
            </div>
        `;

        this.shadowRoot.querySelectorAll(".card").forEach(el => {
            const index = parseInt(el.getAttribute("data-index")!);
            el.addEventListener("click", () => this.handleCardClick(index));
        });
    }
}

customElements.define("memory-game", MemoryGameComponent);
